/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/EndpointDescriptionInput" />
import React = require("react");
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";
import { InputDetails } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { EndpointsEditorPanelUtils } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { InputDataType } from "ServiceEndpoints/Client/Contracts/FormInput_ServiceEndpoint";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ValidatedTextField } from "./ValidatedTextField";
import { IValidationProps } from "./IValidationProps";
import { ValidatedFormItem } from "./ValidatedFormItem";

export class EndpointDescriptionInput extends VssComponent<IValidationProps> {
    private readonly _endpointEditorActionCreator: EndpointsEditorActionsCreator;
    private readonly _endpointEditorStore: EndpointsEditorStore;
    private readonly _validationDetails: InputDetails;
    private readonly _inputId = "endpoint-desc";


    constructor(props: IValidationProps, context: IVssComponentContext) {
        super(props, context);

        this._endpointEditorActionCreator = ActionCreatorManager.GetActionCreator<EndpointsEditorActionsCreator>(EndpointsEditorActionsCreator, ActionsCreatorInstanceIds.EndpointsEditorActionsCreatorInstanceId);

        this._endpointEditorStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);
        const endpoint = this._endpointEditorStore.getEndpoint();

        this._validationDetails = {
            inputId: this._inputId,
            initialValue: endpoint.description,
            inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, false),
            isConfidential: false,
            isUpdate: false
        };
    }

    public render(): JSX.Element {
        const endpoint = this._endpointEditorStore.getEndpoint();

        return (<ValidatedFormItem
            label={Resources.DescriptionInputLabel}
            className="default-input-margin-top"
            inputId={this._inputId}
            validationScopeId={this.props.validationScopeId}>
            <ValidatedTextField
                value={endpoint.description}
                onChange={this._onChange}
                multiline={true}
                validationDetails={this._validationDetails}
                validationScopeId={this.props.validationScopeId} />
        </ValidatedFormItem>);
    }

    private _onChange = (_: any, value: string) => {
        const endpoint = this._endpointEditorStore.getEndpointClone();
        endpoint.description = value;
        this._endpointEditorActionCreator.setServiceEndpoint(endpoint);
    }
}
